import { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import { Page } from "@/components/Page";
import { ProductCard } from "@/components/ProductCard";
import { resolveImg, api } from "@/lib/api";

export default function News() {
  const [news, setNews] = useState([]);

  useEffect(() => {
    api.get("/products", { params: { is_new: true } }).then((r) => setNews(r.data));
  }, []);

  return (
    <Page className="pt-32 md:pt-40 min-h-screen">
      <div className="px-6 md:px-12 max-w-6xl mx-auto">
        <span className="inline-block rounded-full bg-accent text-accent-foreground text-sm font-semibold px-4 py-2">Acabadinho de sair da impressora</span>
        <h1 className="font-display font-black text-4xl md:text-6xl tracking-tighter mt-4">Novidades</h1>
        <p className="text-muted-foreground mt-3 text-lg max-w-xl">As nossas criações mais recentes, fresquinhas e prontas para surpreender.</p>
      </div>

      {news.length > 0 && (
        <div className="my-12 py-4 border-y border-border">
          <Marquee speed={30} gradient={false} autoFill>
            {news.map((p) => (
              <div key={p.id} className="mx-4 w-56 h-40 rounded-3xl overflow-hidden border border-border">
                <img src={resolveImg(p.images?.[0])} alt={p.name} className="w-full h-full object-cover" />
              </div>
            ))}
          </Marquee>
        </div>
      )}

      <div className="px-6 md:px-12 max-w-6xl mx-auto pb-8">
        {news.length === 0 ? (
          <p className="text-center text-muted-foreground py-20">Sem novidades de momento. Volta em breve!</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {news.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
          </div>
        )}
      </div>
    </Page>
  );
}
